/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout-success'
import { Route as HelpRouteImport } from './routes/help'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as DemoScalingRouteImport } from './routes/demo.scaling'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects.$projectId'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'
import { Route as SettingsAvatarsRouteImport } from './routes/settings.avatars'
import { Route as SettingsBadgeRouteImport } from './routes/settings.badge'
import { Route as SettingsBrandRouteImport } from './routes/settings.brand'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsLogosRouteImport } from './routes/settings.logos'
import { Route as SettingsShopvibesRouteImport } from './routes/settings.shopvibes'
import { Route as SettingsSwatchesRouteImport } from './routes/settings.swatches'
import { Route as ShopvibesCallbackRouteImport } from './routes/shopvibes.callback'
import { Route as ProjectsProjectIdIndexRouteImport } from './routes/projects.$projectId.index'
import { Route as ProjectsProjectIdHighlightsRouteImport } from './routes/projects.$projectId.highlights'
import { Route as ProjectsProjectIdLibraryRouteImport } from './routes/projects.$projectId.library'
import { Route as ProjectsProjectIdVideoRouteImport } from './routes/projects.$projectId.video'
import { Route as ProjectsProjectIdWorkflowsRouteImport } from './routes/projects.$projectId.workflows'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/checkout-success',
  path: '/checkout-success',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoScalingRoute = DemoScalingRouteImport.update({
  id: '/demo/scaling',
  path: '/demo/scaling',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAvatarsRoute = SettingsAvatarsRouteImport.update({
  id: '/avatars',
  path: '/avatars',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBadgeRoute = SettingsBadgeRouteImport.update({
  id: '/badge',
  path: '/badge',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBrandRoute = SettingsBrandRouteImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsLogosRoute = SettingsLogosRouteImport.update({
  id: '/logos',
  path: '/logos',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsShopvibesRoute = SettingsShopvibesRouteImport.update({
  id: '/shopvibes',
  path: '/shopvibes',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSwatchesRoute = SettingsSwatchesRouteImport.update({
  id: '/swatches',
  path: '/swatches',
  getParentRoute: () => SettingsRoute,
} as any)
const ShopvibesCallbackRoute = ShopvibesCallbackRouteImport.update({
  id: '/shopvibes/callback',
  path: '/shopvibes/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdIndexRoute = ProjectsProjectIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const ProjectsProjectIdHighlightsRoute =
  ProjectsProjectIdHighlightsRouteImport.update({
    id: '/highlights',
    path: '/highlights',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdLibraryRoute =
  ProjectsProjectIdLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdVideoRoute = ProjectsProjectIdVideoRouteImport.update({
  id: '/video',
  path: '/video',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const ProjectsProjectIdWorkflowsRoute =
  ProjectsProjectIdWorkflowsRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/checkout-success': typeof CheckoutSuccessRoute
  '/help': typeof HelpRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/settings': typeof SettingsRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/demo/scaling': typeof DemoScalingRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/settings/account': typeof SettingsAccountRoute
  '/settings/avatars': typeof SettingsAvatarsRoute
  '/settings/badge': typeof SettingsBadgeRoute
  '/settings/brand': typeof SettingsBrandRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/logos': typeof SettingsLogosRoute
  '/settings/shopvibes': typeof SettingsShopvibesRoute
  '/settings/swatches': typeof SettingsSwatchesRoute
  '/shopvibes/callback': typeof ShopvibesCallbackRoute
  '/settings/': typeof SettingsIndexRoute
  '/projects/$projectId/highlights': typeof ProjectsProjectIdHighlightsRoute
  '/projects/$projectId/library': typeof ProjectsProjectIdLibraryRoute
  '/projects/$projectId/video': typeof ProjectsProjectIdVideoRoute
  '/projects/$projectId/workflows': typeof ProjectsProjectIdWorkflowsRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/checkout-success': typeof CheckoutSuccessRoute
  '/help': typeof HelpRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/demo/scaling': typeof DemoScalingRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/avatars': typeof SettingsAvatarsRoute
  '/settings/badge': typeof SettingsBadgeRoute
  '/settings/brand': typeof SettingsBrandRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/logos': typeof SettingsLogosRoute
  '/settings/shopvibes': typeof SettingsShopvibesRoute
  '/settings/swatches': typeof SettingsSwatchesRoute
  '/shopvibes/callback': typeof ShopvibesCallbackRoute
  '/settings': typeof SettingsIndexRoute
  '/projects/$projectId/highlights': typeof ProjectsProjectIdHighlightsRoute
  '/projects/$projectId/library': typeof ProjectsProjectIdLibraryRoute
  '/projects/$projectId/video': typeof ProjectsProjectIdVideoRoute
  '/projects/$projectId/workflows': typeof ProjectsProjectIdWorkflowsRoute
  '/projects/$projectId': typeof ProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/checkout-success': typeof CheckoutSuccessRoute
  '/help': typeof HelpRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/settings': typeof SettingsRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/demo/scaling': typeof DemoScalingRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/settings/account': typeof SettingsAccountRoute
  '/settings/avatars': typeof SettingsAvatarsRoute
  '/settings/badge': typeof SettingsBadgeRoute
  '/settings/brand': typeof SettingsBrandRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/logos': typeof SettingsLogosRoute
  '/settings/shopvibes': typeof SettingsShopvibesRoute
  '/settings/swatches': typeof SettingsSwatchesRoute
  '/shopvibes/callback': typeof ShopvibesCallbackRoute
  '/settings/': typeof SettingsIndexRoute
  '/projects/$projectId/highlights': typeof ProjectsProjectIdHighlightsRoute
  '/projects/$projectId/library': typeof ProjectsProjectIdLibraryRoute
  '/projects/$projectId/video': typeof ProjectsProjectIdVideoRoute
  '/projects/$projectId/workflows': typeof ProjectsProjectIdWorkflowsRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/checkout-success'
    | '/help'
    | '/library'
    | '/login'
    | '/onboarding'
    | '/settings'
    | '/auth/callback'
    | '/demo/scaling'
    | '/projects/$projectId'
    | '/settings/account'
    | '/settings/avatars'
    | '/settings/badge'
    | '/settings/brand'
    | '/settings/general'
    | '/settings/logos'
    | '/settings/shopvibes'
    | '/settings/swatches'
    | '/shopvibes/callback'
    | '/settings/'
    | '/projects/$projectId/highlights'
    | '/projects/$projectId/library'
    | '/projects/$projectId/video'
    | '/projects/$projectId/workflows'
    | '/projects/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/checkout-success'
    | '/help'
    | '/library'
    | '/login'
    | '/onboarding'
    | '/auth/callback'
    | '/demo/scaling'
    | '/settings/account'
    | '/settings/avatars'
    | '/settings/badge'
    | '/settings/brand'
    | '/settings/general'
    | '/settings/logos'
    | '/settings/shopvibes'
    | '/settings/swatches'
    | '/shopvibes/callback'
    | '/settings'
    | '/projects/$projectId/highlights'
    | '/projects/$projectId/library'
    | '/projects/$projectId/video'
    | '/projects/$projectId/workflows'
    | '/projects/$projectId'
  id:
    | '__root__'
    | '/'
    | '/checkout-success'
    | '/help'
    | '/library'
    | '/login'
    | '/onboarding'
    | '/settings'
    | '/auth/callback'
    | '/demo/scaling'
    | '/projects/$projectId'
    | '/settings/account'
    | '/settings/avatars'
    | '/settings/badge'
    | '/settings/brand'
    | '/settings/general'
    | '/settings/logos'
    | '/settings/shopvibes'
    | '/settings/swatches'
    | '/shopvibes/callback'
    | '/settings/'
    | '/projects/$projectId/highlights'
    | '/projects/$projectId/library'
    | '/projects/$projectId/video'
    | '/projects/$projectId/workflows'
    | '/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
  HelpRoute: typeof HelpRoute
  LibraryRoute: typeof LibraryRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  DemoScalingRoute: typeof DemoScalingRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRouteWithChildren
  ShopvibesCallbackRoute: typeof ShopvibesCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout-success': {
      id: '/checkout-success'
      path: '/checkout-success'
      fullPath: '/checkout-success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/scaling': {
      id: '/demo/scaling'
      path: '/demo/scaling'
      fullPath: '/demo/scaling'
      preLoaderRoute: typeof DemoScalingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/avatars': {
      id: '/settings/avatars'
      path: '/avatars'
      fullPath: '/settings/avatars'
      preLoaderRoute: typeof SettingsAvatarsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/badge': {
      id: '/settings/badge'
      path: '/badge'
      fullPath: '/settings/badge'
      preLoaderRoute: typeof SettingsBadgeRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/brand': {
      id: '/settings/brand'
      path: '/brand'
      fullPath: '/settings/brand'
      preLoaderRoute: typeof SettingsBrandRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/logos': {
      id: '/settings/logos'
      path: '/logos'
      fullPath: '/settings/logos'
      preLoaderRoute: typeof SettingsLogosRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/shopvibes': {
      id: '/settings/shopvibes'
      path: '/shopvibes'
      fullPath: '/settings/shopvibes'
      preLoaderRoute: typeof SettingsShopvibesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/swatches': {
      id: '/settings/swatches'
      path: '/swatches'
      fullPath: '/settings/swatches'
      preLoaderRoute: typeof SettingsSwatchesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/shopvibes/callback': {
      id: '/shopvibes/callback'
      path: '/shopvibes/callback'
      fullPath: '/shopvibes/callback'
      preLoaderRoute: typeof ShopvibesCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/': {
      id: '/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ProjectsProjectIdIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/highlights': {
      id: '/projects/$projectId/highlights'
      path: '/highlights'
      fullPath: '/projects/$projectId/highlights'
      preLoaderRoute: typeof ProjectsProjectIdHighlightsRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/library': {
      id: '/projects/$projectId/library'
      path: '/library'
      fullPath: '/projects/$projectId/library'
      preLoaderRoute: typeof ProjectsProjectIdLibraryRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/video': {
      id: '/projects/$projectId/video'
      path: '/video'
      fullPath: '/projects/$projectId/video'
      preLoaderRoute: typeof ProjectsProjectIdVideoRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/workflows': {
      id: '/projects/$projectId/workflows'
      path: '/workflows'
      fullPath: '/projects/$projectId/workflows'
      preLoaderRoute: typeof ProjectsProjectIdWorkflowsRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
  }
}

interface SettingsRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsAvatarsRoute: typeof SettingsAvatarsRoute
  SettingsBadgeRoute: typeof SettingsBadgeRoute
  SettingsBrandRoute: typeof SettingsBrandRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsLogosRoute: typeof SettingsLogosRoute
  SettingsShopvibesRoute: typeof SettingsShopvibesRoute
  SettingsSwatchesRoute: typeof SettingsSwatchesRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsAvatarsRoute: SettingsAvatarsRoute,
  SettingsBadgeRoute: SettingsBadgeRoute,
  SettingsBrandRoute: SettingsBrandRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsLogosRoute: SettingsLogosRoute,
  SettingsShopvibesRoute: SettingsShopvibesRoute,
  SettingsSwatchesRoute: SettingsSwatchesRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface ProjectsProjectIdRouteChildren {
  ProjectsProjectIdHighlightsRoute: typeof ProjectsProjectIdHighlightsRoute
  ProjectsProjectIdLibraryRoute: typeof ProjectsProjectIdLibraryRoute
  ProjectsProjectIdVideoRoute: typeof ProjectsProjectIdVideoRoute
  ProjectsProjectIdWorkflowsRoute: typeof ProjectsProjectIdWorkflowsRoute
  ProjectsProjectIdIndexRoute: typeof ProjectsProjectIdIndexRoute
}

const ProjectsProjectIdRouteChildren: ProjectsProjectIdRouteChildren = {
  ProjectsProjectIdHighlightsRoute: ProjectsProjectIdHighlightsRoute,
  ProjectsProjectIdLibraryRoute: ProjectsProjectIdLibraryRoute,
  ProjectsProjectIdVideoRoute: ProjectsProjectIdVideoRoute,
  ProjectsProjectIdWorkflowsRoute: ProjectsProjectIdWorkflowsRoute,
  ProjectsProjectIdIndexRoute: ProjectsProjectIdIndexRoute,
}

const ProjectsProjectIdRouteWithChildren =
  ProjectsProjectIdRoute._addFileChildren(ProjectsProjectIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
  HelpRoute: HelpRoute,
  LibraryRoute: LibraryRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  SettingsRoute: SettingsRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  DemoScalingRoute: DemoScalingRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRouteWithChildren,
  ShopvibesCallbackRoute: ShopvibesCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
